module.exports = __webpack_public_path__ + "static/media/Archivo-Bold.0648c4ae.ttf";